import { Fragment, useState, useEffect, useRef } from 'react';
import { useNavigate,useParams } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import Classes from '../createPurchaseOrder/css/create.module.css';
import Aside from './aside';
import Modal from '../createPurchaseOrder/Modal';
import TaxRatesPopup from '../createPurchaseOrder/TaxRates_popup';
import DiscountPopup from '../createPurchaseOrder/addDiscountPopup';
import ShippingPopUp from '../createPurchaseOrder/AddShippingPopup';
import TaxRatesPrint from '../createPurchaseOrder/TaxRatesPrint';
import ConfirmPopup from '../createPurchaseOrder/confirmPopup';
import { Spinner } from 'react-bootstrap';
import SnackBar from '../../../components/SnackBar';
import CreateOrderComponent from '../../../components/createPurchaseOrder/createOrders';
import PaymentDetailsComponent from '../../../components/createPurchaseOrder/paymentDetails';
import { 
    getModalHelper,
    handleTaxAmountHelper,
    hideConfirmPopupHelper,
    addHideModalHelper,
    hideModalHelper,
    handleTaxRatesHelper,
    hideTaxPopupHelper,
    showDiscountPopupHelper,
    hideDiscountPopupHelper,
    shippingPopupHelper,
    hideShippingPopupHelper,
    updateArrHelper,
    incQtyHelper,
    decQtyHelper,
    handleBlurPercentageHelper,
    handleEditHelper,
    handleBlurHelper,
    handleKeyUpHelper,
    handleBlurBulkPackagingQty1Helper,
    handleBlurBulkPackagingQty2Helper,
    incQtyBulkPackagingHelper,
    decQtyBulkPackagingHelper,
    handleBlurQtyHelper,
    formatNumberHelper,
    showLimitDiscountHelper,
    handleSendPIHelper,
    handleUpdateOrderHelper,
    handleChangeHelper, 
    handleEnableSelectHelper,
    handleUpdateExistOrderHelper,
    handleCalculationHelper,
    handleCreateDraftOrderWareHouseHelper,
    handleCreateDraftDraftOrderWareHouseHelper
} from '../../../components/createPurchaseOrder/helperFunction';
import axiosInstance from '../../../utility/axios-instance';
import { LocationAddress, LocationAddressesResponse, PoProductDetail, ProductNewPo, PoCalculationResponse } from '@/types';

interface InterWarehouseInventoryMoveProps {
    setIsCreateOrderPage: (value: boolean) => void;
}

const InterWarehouseInventoryMove = (props: InterWarehouseInventoryMoveProps) => {
    const { setIsCreateOrderPage } = props;
    const [error, setError] = useState<boolean | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [searchProduct, setSearchProduct] = useState('');
    const [productId, setProductId] = useState([]);
    const [variant, setVariant] = useState(0);
    const [addToggleBtn, setAddToggle] = useState<boolean>(false);
    const [showProduct, setProduct] = useState<PoCalculationResponse | null>(null);
    const [toggle, setToggle] = useState<boolean>(false);
    const [variantRole, setVariantRole] = useState([]);
    const [showTaxRate, setTaxRates] = useState<boolean>(false);
    const [discountModal, setDiscountModal] = useState<boolean>(false);
    const [shippingModal, setShippingModal] = useState<boolean>(false);
    const [productDetails, setProductDetails] = useState<PoProductDetail[]>([]);
    const [updateDiscountPercent, setUpdateDiscountPercent] = useState([]);
    const [editDiscountPercent, setDiscountPercent] = useState([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingInterWHCalculationService, setLoadingInterWHCalculationService] = useState<boolean>(false);
    const [notExistProductShopify, setProductNotExistShopify] = useState<boolean>(false);
    const [notExistProductShopifyId, setProductNotExistShopifyId] = useState([]);
    const [lineItems,setLineItems] = useState([]);
    const [snackBar, setSnackBar] = useState({ display: false, type: "success", message: "default message!" })

    // modal
    const [productNew, setProductNew] = useState<ProductNewPo[]>([]);
    const [showConfirmPopup, setConfirmShowPopup] = useState<boolean>(false);

    // ShippingPopUp
    const [shippingPrice, setShippingPrice] = useState([]);
    const [previousTarget, setPreviousTarget] = useState([]);
    const [shippingPriceType, setShippingPriceType] = useState([]);
    const [shippingAmount, setShippingAmount] = useState<boolean>(false);

    // aside
    const [sellerGstNumber, setSellerGstNumber] = useState([]);
    const [customerGstNumber, setCustomerGstNumber] = useState([]);
    const [vendorGstNumber, setVendorGstNumber] = useState("");
    const [BillingAddress, setBillingAddress] = useState([]);
    const [addressArray, setAddressArray] = useState([]);
    const [overAllDiscount, setOverAllDiscount] = useState([]);
    const [draftOrder, setDraftOrder] = useState([]);
    const [showSelectedTags, setSelectedTags] = useState([]);
    const [shippingDetails, setShippingDetails] = useState(null);
    const [paymentDetails, setPaymentDetails] = useState({});
    const [documentsAttached, setDocumentsAttached] = useState([]);
    const [vendorContacts, setVendorContacts] = useState([]);
    const [vendorContactDetails, setVendorContactDetails] = useState(null);

    // store deliveryRemark & notes in State
    const [notes, setNotes] = useState(null);
    const [sellerAddress, setSellerAddress] = useState([]);
    const [sellerLocationDetail, setSellerLocationDetail] = useState([]);
    const [sellerLocationAddress, setSellerLocationAddress] = useState<LocationAddress[]>([]);
    const [sellerLocationBillingAddress, setSellerLocationBillingAddress] = useState<LocationAddress[]>([]);
    const [sellerLocationAddressArray, setSellerLocationAddressArray] = useState<LocationAddress[]>([]);
    const [sellerLocationContacts, setSellerLocationContacts] = useState([]);
    const [sellerLocationContactDetails, setSellerLocationContactDetails] = useState(null);
    const [sellerLocationGstNumber, setSellerLocationGstNumber] = useState("");

    const [customerAddress, setCustomerAddress] = useState([]);
    const [customerLocationDetail, setCustomerLocationDetail] = useState([]);
    const [customerLocationAddress, setCustomerLocationAddress] = useState<LocationAddress[]>([]);
    const [customerLocationBillingAddress, setCustomerLocationBillingAddress] = useState<LocationAddress[]>([]);
    const [customerLocationAddressArray, setCustomerLocationAddressArray] = useState<LocationAddress[]>([]);
    const [customerLocationContact, setCustomerLocationContact] = useState([]);
    const [customerLocationContactDetails, setCustomerLocationContactDetails] = useState(null);
    const [customerLocationGstNumber,setCustomerLocationGstNumber] = useState("");

    // sendPIDraftOrder
    const navigate = useNavigate();
    const { Id } = useParams();

    const inputRef = useRef<HTMLInputElement>(null);
    const handleClick = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    // sendExistOrder
    const [updateToggle, setUpdateToggle] = useState(true);
    const [updateDraftOrderId, setUpdateDraftOrderId] = useState([]);
    const [updateExistOrder, setUpdateExistOrder] = useState(false);
    const [showDiscountType, setDiscountType] = useState([])
    const [specificId, setSpecificId] = useState({});
    const [defaultFiles, setDefaultFiles] = useState([]);
	const [productIdArr, setProductIdArr] = useState<string[]>([]);

    const fetchLocationAddresses = async ({
        locationCode,
        searchText = "",
        isSetDefaultLocationAddresses = false,
        fromWarehouse = true,
      }: {
        locationCode: string,
        searchText: string,
        isSetDefaultLocationAddresses: boolean,
        fromWarehouse: boolean
      }) => {
        axiosInstance
          .get<LocationAddressesResponse>(`/location/locationAddresses/${locationCode}`, {
            params: {
              searchText: searchText,
            },
          })
          .then((res) => {
            const addresses = res?.data?.data;
            if(fromWarehouse){
                setSellerLocationAddressArray(addresses);
            }else{
                setCustomerLocationAddressArray(addresses);
            }
            if (isSetDefaultLocationAddresses) {
                const shippingAddressArrays: LocationAddressesResponse["data"] = [];
                const BillingAddressArrays = [];
                for (let address of addresses) {
                  if (address?.addressType === "Shipping") {
                    shippingAddressArrays?.push(address);
                  } else {
                    BillingAddressArrays?.push(address);
                  }
                }
                if (shippingAddressArrays?.length !== 0) {
                  const selectedShippingAddress =
                    shippingAddressArrays?.find((item) => item?.default === true) ||
                    shippingAddressArrays?.[0];
                    if(fromWarehouse){
                        setSellerLocationAddress([selectedShippingAddress]);
                    }else{
                        setCustomerLocationAddress([selectedShippingAddress]);
                    }
                }
    
                if (BillingAddressArrays?.length !== 0) {
                  const selectedBillingAddress =
                    BillingAddressArrays?.find((item) => item?.default === true) ||
                    BillingAddressArrays?.[0] ||
                    shippingAddressArrays?.[0];
                    if(fromWarehouse){
                        setSellerLocationBillingAddress([selectedBillingAddress]);
                    }else{
                        setCustomerLocationBillingAddress([selectedBillingAddress]);
                    }
                } else {
                    if(fromWarehouse){
                        setSellerLocationBillingAddress([]);
                    }else{
                        setCustomerLocationBillingAddress([]);
                    }
                }
            }
          })
          .catch((error) => {
            if(fromWarehouse){
                setSellerLocationAddressArray([]);
            }else{
                setCustomerLocationAddressArray([]);
            }
            console.log(error);
          });
      };

    // show Modal popup
    const getModal = ( searchItem: string ) => {
        const outlineElement = document.getElementById('outline');
        if (outlineElement) {
            outlineElement.style.border = '1px solid rgb(206, 212, 218)';
        }
        const searchElement = document.getElementById('search') as HTMLInputElement;
        if (searchElement) {
            searchElement.value = '';
        }
        getModalHelper(searchItem, setToggle, setSearchProduct, setShowModal);
    };

    const handleTaxAmount = (amount: number): number => {
        return handleTaxAmountHelper(amount);
    }

    const hideConfirmPopup = (event: React.MouseEvent<HTMLButtonElement>) => {
        hideConfirmPopupHelper(event, setConfirmShowPopup);
    }

    // AddProductButton&HideModal
    const addHideModal = () => {
        addHideModalHelper(
            setSearchProduct,setVariant,productIdArr,setShowModal,setAddToggle,
            productNew,productDetails,setProductId,setProductDetails,setProductNew
        );
    };

    // hide modal popup
    const hideModal = () => {
        hideModalHelper(setSearchProduct,productIdArr,setVariant,productId,setShowModal);
    };

    // show TaxRate Popup
    const handleTaxRates = () => {
        handleTaxRatesHelper(setTaxRates);
    };

    // hide TaxRate Popup
    const hideTaxPopup = () => {
        hideTaxPopupHelper(setTaxRates);
    };

    // show discount popup
    const showDiscountPopup = () => {
        showDiscountPopupHelper(setDiscountModal);
    };

    // hide Discount popup
    const hideDiscountPopup = () => {
        hideDiscountPopupHelper(setDiscountModal);
    };

    const shippingPopup = () => {
        shippingPopupHelper(setShippingModal);
    };

    const hideShippingPopup = () => {
        hideShippingPopupHelper(setPreviousTarget,setShippingModal);
    };

    const setLoadingInterWHCalculationServiceState = (value:boolean) => {
        setLoadingInterWHCalculationService(value);
    }

    document.addEventListener('mouseup', function (e) {
        let container = document.getElementById('outline');
        if (container !== null) {
            if (!container.contains(e.target as Node)) {
                container.style.border = '1px solid rgb(206, 212, 218)';
            }
        }
    });

    const handleOutline = () => {
        const outlineElement = document.getElementById('outline');
        if (outlineElement) {
            outlineElement.style.border = '2px solid #458fff';
        }
    };

    // remove product from array
    const updateArr = (Id:string) => {
        updateArrHelper(
            Id,productDetails,notExistProductShopifyId,setProductNotExistShopifyId,
            setProductNotExistShopify,setProductId,setProductDetails,setAddToggle,
            setVariantRole,variantRole,setProduct,setOverAllDiscount,setShippingPrice,
            setPreviousTarget
        );
    };

    // increase qty from product
    const incQty = (Id:string,bulkPacking1:number,bulkPacking2:number) => {
        incQtyHelper(
            Id,bulkPacking1,bulkPacking2,productDetails,setAddToggle,
            setProductId,setProductDetails
        );
    };

    // decrease qty from product
    const decQty = (Id:string,bulkPacking1:number,bulkPacking2:number) => {
        decQtyHelper(
            Id,bulkPacking1,bulkPacking2,productDetails,setAddToggle,setProductId,
            setProductDetails
        );
    };

    // Handle Manually Percentage
    const handleEditPercentage = (event: React.ChangeEvent<HTMLInputElement>) => {
        return handleEditHelper(event)
    };

    // Handle Blur Percentage
    const handleBlurPercentage = (
        event: React.ChangeEvent<HTMLInputElement>, 
        Id: string, 
        MRP: number, 
        GST: number, 
        originalUnitPrice: number
    ) => {
        handleBlurPercentageHelper(
            event, Id, MRP, GST, originalUnitPrice, productDetails,
            updateDiscountPercent, setUpdateDiscountPercent, setAddToggle, setProductId,
            setProductDetails
        );
    };

    const handleEdit = (event: React.KeyboardEvent<HTMLParagraphElement>) => {
        handleEditHelper(event);
    };

    // handle Blur Rate(Price)
    const handleBlur = (event: React.FocusEvent<HTMLDivElement>, Id: string, previousUnit: number, MRP: number) => {
        handleBlurHelper(
            event, Id, previousUnit, MRP,productDetails,setAddToggle,setProductId,
            setProductDetails
        )
    };

    // OnQty Blur Handled
    const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        handleKeyUpHelper(event)
    }

    const handleBlurBulkPackagingQty1 = (value: string, Id: string, bulkPackagingValue: number, type: string, bulkPackagingValue2: number, restrictMsgId: string) => {
        handleBlurBulkPackagingQty1Helper(
            value, Id, bulkPackagingValue, type, bulkPackagingValue2, restrictMsgId,
            productDetails, setAddToggle, setProductId, setProductDetails
        )
    };

    const handleBlurBulkPackagingQty2 = (value: string, Id: string, bulkPackagingValue: number, type: string, bulkPackagingValue1: number, restrictMsgId: string) => {
        handleBlurBulkPackagingQty2Helper(
            value, Id, bulkPackagingValue, type, bulkPackagingValue1, restrictMsgId,
            productDetails, setAddToggle, setProductId, setProductDetails
        )
    };

    // increase qty from product
    const incQtyBulkPackaging = (Id:string, bulkPackagingValue:number, type:string) => {
        incQtyBulkPackagingHelper(
            Id, bulkPackagingValue, type, productDetails, setAddToggle, setProductId,
            setProductDetails
        )
    };

    const decQtyBulkPackaging = (Id:string, bulkPackagingValue:number, type:string) => {
        decQtyBulkPackagingHelper(
            Id, bulkPackagingValue, type, productDetails, setAddToggle, setProductId,
            setProductDetails
        )
    };

    // handle Blur Qty
    const handleBlurQty = (value: number, Id: string, bulkPacking1: number, bulkPacking2: number, restrictMsgId: string) => {
        handleBlurQtyHelper(
            value, Id, bulkPacking1, bulkPacking2, restrictMsgId, productDetails, setAddToggle,
            setProductId, setProductDetails
        );
    };

    const formatNumber = (number:number) => {
        return formatNumberHelper(number);
    };

    // showLimitDiscount
    const showLimitDiscount = (mrp: number, originalUnitPrice: number, value: number): number => {
        return showLimitDiscountHelper(mrp, originalUnitPrice, value);
    };

    const handleEnableSelect = () => {
        handleEnableSelectHelper();
    }

    // Open Window Print
    const handleSendPI = (event: React.MouseEvent<HTMLButtonElement>) => {
        handleSendPIHelper(event,overAllDiscount);
    }

    const handleCreateDraftOrderWareHouse = (event: React.MouseEvent<HTMLButtonElement>) => {
        handleCreateDraftOrderWareHouseHelper(
            event, sellerLocationDetail, customerLocationDetail, showProduct, productDetails, 
            customerLocationGstNumber, sellerLocationAddress,
            sellerLocationBillingAddress, sellerLocationGstNumber, overAllDiscount, paymentDetails,
            shippingPrice, setShippingDetails, shippingDetails, documentsAttached,
            sellerLocationContactDetails, customerLocationContactDetails, notes, navigate,
            setIsCreateOrderPage, customerLocationAddress, customerLocationBillingAddress, setLoading, setSnackBar
        )
    }

    const handleCreateDraftDraftOrder = (event: React.MouseEvent<HTMLButtonElement>) => {
        handleCreateDraftDraftOrderWareHouseHelper(
            event, sellerLocationDetail, customerLocationDetail, showProduct, productDetails, 
            customerLocationGstNumber, sellerLocationAddress,
            sellerLocationBillingAddress, sellerLocationGstNumber, overAllDiscount, paymentDetails,
            shippingPrice, setShippingDetails, shippingDetails, documentsAttached,
            sellerLocationContactDetails, customerLocationContactDetails, notes, navigate,
            setIsCreateOrderPage, customerLocationAddress, customerLocationBillingAddress, setLoading, setSnackBar
        )
    }

    // Update Exist Order
    const handleUpdateOrder = (event: React.MouseEvent<HTMLButtonElement>) => {
        handleUpdateOrderHelper(
            event, sellerLocationDetail, customerLocationDetail, showProduct, productDetails, 
            sellerLocationAddress, sellerLocationBillingAddress, sellerLocationGstNumber, customerLocationAddress,
            customerLocationBillingAddress, customerLocationGstNumber, overAllDiscount, paymentDetails,
            shippingDetails, documentsAttached, customerLocationContactDetails, sellerLocationContactDetails,
            notes, navigate, specificId, setSellerLocationContactDetails, setCustomerLocationContactDetails,
            defaultFiles, draftOrder, updateDraftOrderId, undefined, false,
            setIsCreateOrderPage, 'draftInterWarehouseInventoryMoves', setSnackBar
        )
    }

    useEffect(() => {
        if (Id && updateToggle) {
            let timeoutId = setTimeout(() => {
                handleUpdateExistOrderHelper(
                    Id, setUpdateExistOrder, setDraftOrder, [], setUpdateDraftOrderId, setShippingDetails,
                    setPaymentDetails, setSellerLocationContactDetails, setSellerLocationGstNumber, setCustomerLocationContactDetails, setNotes,
                    setCustomerLocationGstNumber, setSpecificId, setDefaultFiles, setUpdateDiscountPercent, setDiscountPercent,
                    setOverAllDiscount, setShippingPrice, setProductId, setProductDetails, setProduct, undefined,
                    handleEnableSelect, setUpdateToggle, setLineItems, setSellerLocationDetail, setSellerLocationAddressArray, setSellerLocationAddress,
                    setSellerLocationBillingAddress, setSellerLocationContacts, setCustomerLocationDetail, setCustomerLocationAddressArray,
                    setCustomerLocationAddress, setCustomerLocationBillingAddress, setCustomerLocationContact, 'InterWarehouse', setLoadingInterWHCalculationServiceState
                )
            }, 500)
            return () => clearTimeout(timeoutId)
        }
    }, [Id, updateToggle])

    useEffect(() => {
        setProduct(showProduct)
    },[showProduct])


    useEffect(() => {
        if (addToggleBtn && productDetails?.length !== 0) {
            let timeoutId = setTimeout(() => {
                handleCalculationHelper(
                    lineItems, sellerLocationAddress, sellerAddress, productDetails, overAllDiscount,
                    shippingPrice, setAddToggle, updateDiscountPercent, setDiscountPercent,
                    editDiscountPercent, setLineItems, setProduct, setLoadingInterWHCalculationServiceState
                )
            }, 500)
            return () => clearTimeout(timeoutId)
        }
    }, [addToggleBtn, showProduct, overAllDiscount, productDetails, shippingPrice,
        updateDiscountPercent, editDiscountPercent, sellerLocationAddress, sellerAddress,
        lineItems, customerAddress
    ]);

    useEffect(() => {
        setIsCreateOrderPage(true);
    }, [])
    
    const handleChange = (value: any, sku: string) => {
        handleChangeHelper(value, sku, lineItems, setLineItems);
    }

    return (
        <Fragment>
            {loading ? (
                <div
                    style={{
                        position:'fixed', top:'50%', left:'50%',
                        transform:'translate(-50%, -50%)',
                        backgroundColor:'rgba(0, 0, 0, 0.5)',
                        zIndex:'9999', height:'100%', width:'100%',
                        display:'flex', justifyContent: 'center',
                        alignItems:'center',
                    }}
                >
                    <Spinner animation="border" variant="light" />
                </div>
            ) : null}

            <div className={Classes.container} id="color">
                {error ? (
                    <Alert variant="danger" onClose={() => setError(false)} dismissible>
                        <Alert.Heading>{error}</Alert.Heading>
                        <p>Try reloading!</p>
                    </Alert>
                ) : null}

                <div className={Classes.mainContainer} style={{ marginTop:30 }}>
                    <div className={Classes.containBoxes} id='createOrderProducts'>
                        <CreateOrderComponent 
                            handleEdit={handleEdit}
                            handleBlur={handleBlur}
                            handleOutline={handleOutline}
                            getModal={getModal}
                            showProduct={showProduct}
                            handleEditPercentage={handleEditPercentage}
                            handleBlurPercentage={handleBlurPercentage}
                            showLimitDiscount={showLimitDiscount}
                            handleChange={handleChange}
                            handleBlurQty={handleBlurQty}
                            incQty={incQty}
                            decQty={decQty}
                            handleBlurBulkPackagingQty1={handleBlurBulkPackagingQty1}
                            handleKeyUp={handleKeyUp}
                            incQtyBulkPackaging={incQtyBulkPackaging}
                            decQtyBulkPackaging={decQtyBulkPackaging}
                            handleBlurBulkPackagingQty2={handleBlurBulkPackagingQty2}
                            updateArr={updateArr}
                            active={true}
                            setProductDetails={setProductDetails}
                            setAddToggle={setAddToggle}
                            componentType={'Inter WareHouse'}
                        />

                        <PaymentDetailsComponent 
                            showProduct={showProduct}
                            showDiscountPopup={showDiscountPopup}
                            handleClick={handleClick}
                            handleTaxRates={handleTaxRates}
                            handleTaxAmount={handleTaxAmount}
                            showCustomerDetail={[]}
                            showLocationDetail={sellerLocationDetail}
                            sellerLocationAddress={sellerLocationAddress}
                            sellerLocationBillingAddress={sellerLocationBillingAddress}
                            customerLocationDetail={customerLocationDetail}
                            customerLocationAddress={customerLocationAddress}
                            customerLocationBillingAddress={customerLocationBillingAddress}
                            updateExistOrder={updateExistOrder}
                            notExistProductShopify={notExistProductShopify}
                            handleCreateDraftOrder={handleCreateDraftOrderWareHouse}
                            handleSendPI={handleSendPI}
                            handleUpdateOrder={handleUpdateOrder}
                            handleCreateDraftDraftOrder={handleCreateDraftDraftOrder}
                            buttonText={"Create WareHouse Inventory Move"}
                            active={true}
                            loadingPurchaseOrderCalculationService={loadingInterWHCalculationService}
                        />

                        {showProduct && (
                            <div id='TaxRatesPrint' style={{ display: 'none' }}>
                                <TaxRatesPrint
                                    showProduct={showProduct}
                                    showCustomerDetail={[]}
                                    addressArray={addressArray}
                                    customerIDAddress={sellerAddress}
                                />
                            </div>
                        )}

                        <div>
                            <ConfirmPopup
                                showConfirmPopup={showConfirmPopup}
                                hideConfirmPopup={hideConfirmPopup}
                            />
                        </div>
                    </div>

                    <div className={Classes.asideContainer} id='createOrderAsideContainer'>
                        <Aside
                            shippingDetails={shippingDetails}
                            setShippingDetails={setShippingDetails}
                            paymentDetails={paymentDetails}
                            setPaymentDetails={setPaymentDetails}
                            sellerLocationDetail={sellerLocationDetail}
                            sellerAddress={sellerAddress}
                            setSellerAddress={setSellerAddress}
                            setSellerLocationDetail={setSellerLocationDetail}
                            sellerLocationAddress={sellerLocationAddress}
                            setSellerLocationAddress={setSellerLocationAddress}
                            sellerLocationBillingAddress={sellerLocationBillingAddress}
                            setSellerLocationBillingAddress={setSellerLocationBillingAddress}
                            sellerLocationAddressArray={sellerLocationAddressArray}
                            setSellerLocationAddressArray={setSellerLocationAddressArray}
                            sellerLocationContacts={sellerLocationContacts}
                            setSellerLocationContacts={setSellerLocationContacts}
                            sellerLocationContactDetails={sellerLocationContactDetails}
                            setSellerLocationContactDetails={setSellerLocationContactDetails}
                            sellerLocationGstNumber={sellerLocationGstNumber}
                            setSellerLocationGstNumber={setSellerLocationGstNumber}
                            customerLocationDetail={customerLocationDetail}
                            setCustomerLocationDetail={setCustomerLocationDetail}
                            customerLocationAddress={customerLocationAddress}
                            setCustomerLocationAddress={setCustomerLocationAddress}
                            customerLocationBillingAddress={customerLocationBillingAddress}
                            setCustomerLocationBillingAddress={setCustomerLocationBillingAddress}
                            customerLocationAddressArray={customerLocationAddressArray}
                            setCustomerLocationAddressArray={setCustomerLocationAddressArray}
                            customerLocationContact={customerLocationContact}
                            setCustomerLocationContact={setCustomerLocationContact}
                            customerLocationContactDetails={customerLocationContactDetails}
                            setCustomerLocationContactDetails={setCustomerLocationContactDetails}
                            customerLocationGstNumber={customerLocationGstNumber}
                            setCustomerLocationGstNumber={setCustomerLocationGstNumber}
                            customerAddress={customerAddress}
                            setCustomerAddress={setCustomerAddress}
                            sellerGstNumber={sellerGstNumber}
                            setSellerGstNumber={setSellerGstNumber}
                            customerGstNumber={customerGstNumber}
                            setCustomerGstNumber={setCustomerGstNumber}
                            BillingAddress={BillingAddress}
                            setBillingAddress={setBillingAddress}
                            showSelectedTags={showSelectedTags}
                            setSelectedTags={setSelectedTags}
                            addressArray={addressArray}
                            setAddressArray={setAddressArray}
                            updateExistOrder={updateExistOrder}
                            notes={notes}
                            setNotes={setNotes}
                            style={Classes}
                            files={documentsAttached}
                            setFiles={setDocumentsAttached}
                            defaultFiles={defaultFiles}
                            setDefaultFiles={setDefaultFiles}
                            vendorContacts={vendorContacts}
                            setVendorContacts={setVendorContacts}
                            vendorContactDetails={vendorContactDetails}
                            setVendorContactDetails={setVendorContactDetails}
                            vendorGstNumber={vendorGstNumber}
                            setVendorGstNumber={setVendorGstNumber}
                            shippingPrice={shippingPrice}
                            overAllDiscount={overAllDiscount}
                            productDetails={productDetails}
                            setProduct={setProduct}
                            setShippingPrice={setShippingPrice}
                            inputRef={inputRef}
                            setLoadingInterWHCalculationServiceState={setLoadingInterWHCalculationServiceState}
                            fetchLocationAddresses={fetchLocationAddresses}
                        />
                    </div>
                </div>
            </div>

            <div className={shippingModal ? Classes.UpdateSalesDialog : undefined}>
                <ShippingPopUp
                    shippingModal={shippingModal}
                    setShippingModal={setShippingModal}
                    shippingPopup={shippingPopup}
                    hideShippingPopup={hideShippingPopup}
                    productDetails={productDetails}
                    setProduct={setProduct}
                    shippingPrice={shippingPrice}
                    previousTarget={previousTarget}
                    shippingAmount={shippingAmount}
                    setShippingAmount={setShippingAmount}
                    setPreviousTarget={setPreviousTarget}
                    shippingPriceType={shippingPriceType}
                    setShippingPriceType={setShippingPriceType}
                    setShippingPrice={setShippingPrice}
                    overAllDiscount={overAllDiscount}
                    setLoadingPurchaseOrderCalculationServiceState={setLoadingInterWHCalculationServiceState}
                />
            </div>

            <div className={discountModal ? Classes.UpdateSalesDialog : undefined}>
                <DiscountPopup
                    discountModal={discountModal}
                    setDiscountModal={setDiscountModal}
                    showDiscountPopup={showDiscountPopup}
                    hideDiscountPopup={hideDiscountPopup}
                    productDetails={productDetails}
                    setProduct={setProduct}
                    overAllDiscount={overAllDiscount}
                    shippingPrice={shippingPrice}
                    showDiscountType={showDiscountType}
                    setDiscountType={setDiscountType}
                    setShippingPrice={setShippingPrice}
                    setOverAllDiscount={setOverAllDiscount}
                    setLoadingPurchaseOrderCalculationServiceState={setLoadingInterWHCalculationServiceState}
                />
            </div>

            <div className={showTaxRate ? Classes.UpdateSalesDialog : undefined}>
                <TaxRatesPopup
                    showTaxRate={showTaxRate}
                    handleTaxRates={handleTaxRates}
                    hideTaxPopup={hideTaxPopup}
                    taxLines={showProduct}
                    formatNumber={formatNumber}
                    draftOrder={showProduct ? {DpoTaxLines:showProduct?.taxLines,DpoPaymentDetails: {totalTaxAmount: showProduct?.totalTaxAmount}} : draftOrder}
                />
            </div>

            <div className={showModal ? Classes.UpdateSalesDialog : undefined}>
                <Modal
                    show={showModal}
                    onHide={hideModal}
                    AddHide={addHideModal}
                    styles={Classes}
                    search={searchProduct}
                    setSearch={setSearchProduct}
                    productArr={productId}
                    variant={variant}
                    setVariant={setVariant}
                    toggle={toggle}
                    setToggle={setToggle}
                    productNew={productNew}
                    setProductNew={setProductNew}
                    productIdArr={productIdArr}
                    setProductIdArr={setProductIdArr}
                    componentType={'Inter WareHouse'}
                    active={true}
                />
            </div>

            <SnackBar snackBar={snackBar} setSnackBar={setSnackBar} />
        </Fragment>
    );
};

export default InterWarehouseInventoryMove;